import React, { useEffect, useState, useRef } from "react";
import AddIcon from "@mui/icons-material/Add";
import { useNavigate } from "react-router-dom";
import { fetchProfessionalTournaments } from "../../action/professionalTournamentsAction";
import { useDispatch, useSelector } from "react-redux";
import BlankImg from "../../assets/images/blank.jpg";
import { ImageWithFallback } from "../../helper/helper";
import Pagination from "../../component/Pagination";
import $ from "jquery";
import moment from "moment";
import "datatables.net-dt/css/dataTables.dataTables.min.css";
import "datatables.net-responsive-dt/css/responsive.dataTables.css";
import "datatables.net-buttons-dt/css/buttons.dataTables.css";
import "datatables.net";
import "datatables.net-responsive";
import "datatables.net-buttons";
import {
  Box,
  Paper,
  styled,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
  // Checkbox,
  Button,
  Modal,
  Link,
  IconButton,
  Switch,
} from "@mui/material";
import DeleteIcon from "../../assets/images2/deleteIcon.svg";
import { fetchTournamentData } from "../../action/tournamentsAction";
import { defineLocale } from "moment/moment";
import VisibilityIcon from "@mui/icons-material/Visibility";
import CheckBox from "../../component/CheckBox";
import axios from "axios";
import { ToastContainer, toast } from "react-toastify";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import PlayArrowIcon from "@mui/icons-material/PlayArrow";
import TournamentVideoDeleteModal from "../../component/Modals/DeleteModal";
// import ViewTournament from "../../../component/Modals/ViewTournament";
import ViewTournament from "../../component/Modals/ViewTournament";
import LisitingSkeleton from "../common/LisitingSkeleton";
import DeleteIconMui from "@mui/icons-material/Delete";
import CustomDeleteModal from "../../component/Modals/CustomDeleteModal";
import ProfessionalVideoView from "../../component/Modals/ProfessionalVideoView";
import EditIcon from "@mui/icons-material/Edit";
import StatusSwitch from "../../component/admin/professionalTournaments/StatusSwitch";
import { useAuth } from "../../context/auth";

const goalsColumn = [
  { id: "tournament_select", label: "", minWidth: 105 },
  { id: "tournament_title", label: "TITLE", minWidth: 105 },
  { id: "tournament_description", label: "DESCRIPTION", minWidth: 210 },
  // { id: "tournament_category", label: "CATEGORY", minWidth: 210 },
  { id: "tournament_videos", label: "VIDEOS", minWidth: 290 },
  { id: "tournament_actions", label: "ACTIONS", minWidth: 290 },
];

const InternationalTournaments = () => {
  const navigate = useNavigate();
  const professionalTournamentData = useSelector(
    (state) => state.professionalTournament
  );
  const token = useSelector((state) => state.auth.token);
  const [goals, setGoals] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(0);
  const dispatch = useDispatch();
  const tableRef = useRef(null);
  const [selectall, setSelectAll] = useState(false);
  const multipleSelect = useRef(new Map());
  const [openDelete, setOpenDelete] = useState(false);
  const deleteSelected = useRef(null);
  const deleteChildSelected = useRef(null);
  const [userView, setUserView] = useState(false);
  const [viewVideo, setViewVideo] = useState(false);

  // current selected for delete modal
  const currentRef = useRef(null);
  // current call back selected for delete modal
  const currentCallback = useRef(null);
  // current custom text
  // const [currentText, setCurrentText] = useState(null);
  const currentTextRef = useRef(null);

  const { goalFormState, setGoalFormState } = useAuth();


  useEffect(() => {
    dispatch(fetchProfessionalTournaments(token, 1));
  }, [dispatch, token]);

  useEffect(() => {
    if (professionalTournamentData?.data?.success) {
      if (professionalTournamentData?.data?.data.length > 0) {
        // setGoals("NO Leads!");
        setGoals(professionalTournamentData.data?.data);
        setCurrentPage(professionalTournamentData?.data?.currentPage);
        setTotalPages(Math.ceil(professionalTournamentData?.data?.count / 10));
      } else {
        setGoals("NO Tournament Found");
      }
    } else if (!professionalTournamentData?.data?.success) {
      setGoals(professionalTournamentData?.data?.message);
    }
  }, [professionalTournamentData]);

  const handleChangePage = (event, newPage) => {
    dispatch(fetchProfessionalTournaments(token, newPage));
  };

  const handleDeleteTournament = async (ref) => {

    if (ref.current && ref.current?.id) {
      try {
        const response = await axios.delete(
          `${process.env.REACT_APP_API_URL}/deleteProfessionalTournament/${ref.current.id}`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
        if (response.data.success) {
          dispatch(fetchProfessionalTournaments(token, currentPage));
          toast.success("Professional Tournament deleted successfully");
        }
      } catch (error) {
        toast.error("Please try again..");
      } finally {
        setOpenDelete(false);
      }
    } else {
      toast.error("error!!");
    }
  };

  async function handleMultipleDelete(ref) {
    try {
      const ids = Array.from(ref.current.entries()).map((ele) => ele[0]);
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/deleteMultipleProfessionalTournament`,
        {
          ids,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      if (response.data.success) {
        dispatch(fetchProfessionalTournaments(token, currentPage));
        toast.success("Selected Professional Tournaments deleted successfully");
      } else {
        toast.error(response.message);
      }
    } catch (error) {
      toast.error("Please try again..");
    } finally {
      multipleSelect.current.clear();
      // setOpenMulitDelete(false);
      setOpenDelete(false);
    }
  }

  return (
    <>
      <ToastContainer />
      <Box className="page_title custom-header">
        <Typography variant="h1" component="h1">
          International Tournaments
        </Typography>

        {/* <DeleteOutlineIcon className="delete-icon" /> */}
        <Box sx={{ display: "flex", gap: "10px" }}>
          <IconButton
            onClick={() => {
              if (
                Array.from(multipleSelect.current.entries()).map(
                  (ele) => ele[0]
                ).length == 0 ||
                !multipleSelect.current
              ) {
                toast.error("select the Professional Tournament");
                return;
              } else {
              }
              currentRef.current = multipleSelect.current;
              // multipleSelect.current.clear();
              currentCallback.current = handleMultipleDelete;
              currentTextRef.current =
                "Are You Sure . You want to delete these Selected Professional Tournaments.";

              setOpenDelete(true);
              // setCurrentText(
              //   "Are You Sure . You want to delete these Selected Banners."
              // );
            }}
          >
            <DeleteIconMui />
          </IconButton>
          <Button
            className="create-custom"
            onClick={() =>
              navigate(
                "/admin/dashboard/international-tournament/create-international-tournament"
              )
            }
          >
            <AddIcon className="delete-icon" /> Create
          </Button>
        </Box>
      </Box>
      <Box className="page_inner">
        <Box className="page_table tournament">
          <TableContainer
            component={Paper}
            className="customer_form user_table"
          >
            <Table
              aria-label="leads table"
              id="leadsTable"
              className="display responsive nowrap"
              style={{ width: "100%", minWidth: "900px" }}
            >
              <TableHead className="table_Head">
                <TableRow key="tb_head_tournament">
                  {goalsColumn.map((column) =>
                    column.id != "tournament_select" ? (
                      <TableCell key={column.id}>{column.label}</TableCell>
                    ) : (
                      <TableCell key={column.id}>
                        <Box className="checkbox-td">
                          <input
                            type="checkbox"
                            className="siteCheckBox"
                            checked={selectall}
                            onChange={(e) => {
                              if (!e.target.checked) {
                                multipleSelect.current.clear();
                              }
                              setSelectAll(e.target.checked);
                            }}
                          />
                        </Box>
                      </TableCell>
                    )
                  )}
                </TableRow>
              </TableHead>
              <TableBody>
                {Array.isArray(goals) && goals.length > 0 ? (
                  goals.map((value, index) => (
                    <TableRow key={index}>
                      <TableCell>
                        <Box className="checkbox-td">
                          <CheckBox
                            multipleSelect={multipleSelect}
                            selectall={selectall}
                            data={value}
                            key={value.id}
                          />
                        </Box>
                      </TableCell>
                      <TableCell>
                        <Box className="property_name">
                          <Typography
                            variant="h4"
                            component="h4"
                            className="t_title"
                          >
                            {value?.title}
                          </Typography>
                        </Box>
                      </TableCell>

                      <TableCell>
                        <Box className="td-wrapper">
                          <Typography
                            variant="p"
                            component="p"
                            className="table-text"
                          >
                            {value?.description}
                          </Typography>
                        </Box>
                      </TableCell>
                      {/* <TableCell>
                        <Box className="td-wrapper">
                          <Typography
                            variant="p"
                            component="p"
                            className="table-text"
                          >
                            {value?.categoryName}
                          </Typography>
                        </Box>
                      </TableCell> */}

                      <TableCell>
                        <Box className="td-wrapper">
                          <Typography
                            variant="p"
                            component="p"
                            className="table-text"
                          >
                            <a
                              href=""
                              className="tournament_video"
                              onClick={(e) => {
                                e.preventDefault();
                                currentRef.current = value;
                                setViewVideo(true);
                              }}
                            >
                              {value?.videoCount + " Videos"}
                            </a>
                          </Typography>
                        </Box>
                      </TableCell>
                      <TableCell>
                        <Box className="table-actions">
                          <Box className="action-wrapper">
                            <Button
                              variant="text"
                              onClick={() => {
                                deleteSelected.current = value;
                                deleteSelected.current = value;
                                // setCurrentSelect(value);
                                currentRef.current = value;
                                // setCurrentCallback(handleDeleteBanner);
                                currentCallback.current =
                                  handleDeleteTournament;
                                currentTextRef.current =
                                  "Are You Sure . You want to delete this Professional Tournament.";
                                setOpenDelete(true);
                                // setOpenDelete(true);
                              }}
                            >
                              <img src={DeleteIcon} alt="" />
                            </Button>
                            <Button
                              variant="outlined"
                              className="visible_user"
                              onClick={() => {
                                navigate(
                                  "/admin/dashboard/international-tournament/edit-international-tournament/" +
                                    value.id
                                );
                                // deleteSelected.current = value;
                                // setUserView(true);
                              }}
                            >
                              <EditIcon className="visible_icon" />
                            </Button>

                            <StatusSwitch value={value} />
                          </Box>
                        </Box>
                      </TableCell>
                    </TableRow>
                  ))
                ) : goals !== "No Leads!" ? (
                  // <TableRow component={`tr`}>
                  // {/* <TableCell colSpan={5}>Loading...</TableCell> */}
                  Array.from({ length: 10 }).map((e, i) => <LisitingSkeleton />)
                ) : (
                  // </TableRow>
                  <TableRow component={`tr`}>
                    <TableCell colSpan={5} style={{ textAlign: "center" }}>
                      {goals}
                    </TableCell>
                  </TableRow>
                )}
              </TableBody>
            </Table>
          </TableContainer>
          {totalPages > 1 && (
            <Pagination
              currentPage={currentPage}
              totalPages={totalPages}
              handleChangePage={handleChangePage}
            />
          )}
        </Box>
      </Box>

      {/* custom delete modal  */}

      {/* custom delete modal */}
      <CustomDeleteModal
        open={openDelete}
        setOpen={setOpenDelete}
        selected={currentRef}
        deleteCallBack={currentCallback}
        customText={currentTextRef.current}
      />

      {/* view video modal  */}

      <ProfessionalVideoView
        setOpen={setViewVideo}
        open={viewVideo}
        selected={currentRef}
      />
    </>
  );
};

export default InternationalTournaments;
